<script lang="ts">
  import { beforeNavigate } from "$app/navigation";
  import { upgradePitch } from "./upgrade.svelte.ts";

  const shown = upgradePitch();

  beforeNavigate(() => {
    shown.open = false;
  });
</script>

{#if shown.pitch !== null && shown.pitch.tier !== null}
  {@const pitch = shown.pitch}
  {@const tier = shown.pitch.tier}
  {#await import("./UpgradeDialog.svelte") then { default: UpgradeDialog }}
    <UpgradeDialog bind:open={shown.open} {pitch} {tier} />
  {/await}
{/if}
